import { ApiClient } from "../helpers/apiClient";
import { EventDTO } from "../contexts/EventContext";
import { AccountInfo } from "@azure/msal-browser";
import { ParticipantDTO } from "../components/Dashboard";
import { EventStatusFilter } from "../enums/EventStatusFilter";

export async function loadParticipantsForEvent(
  instance: any,
  account: AccountInfo,
  apiBaseUrl: string | undefined,
  event: EventDTO | undefined,
  eventStatusFilter: EventStatusFilter | undefined,
): Promise<ParticipantDTO[]> {
  const apiClient = ApiClient.getInstance(instance, account, {
    baseUrl: apiBaseUrl,
  });

  const allParticipants =
    (await apiClient?.get<ParticipantDTO[]>(
      `Participant?eventID=${event?.eventID}&eventStatusFilter=${eventStatusFilter}`,
    )) ?? [];

  if (event?.locationName) {
    const city = event.locationName.trim().toLowerCase();
    return allParticipants.filter((p) => {
      const loc = (p.location ?? "").trim().toLowerCase();
      return loc === "" || loc === city;
    });
  }

  return allParticipants;
}
